import { enTranslation } from './translations'
import type { ConnectwareAdminWebAppConfig } from './WebAppConfig'
import { version } from '../../../package.json'

export const config: ConnectwareAdminWebAppConfig = {
    translations: enTranslation,

    displayVersion: version,

    backendHost: null,

    contact: { salesEmail: 'sales@cybus.io', supportEmail: 'support@cybus.io' },

    userManagement: {
        protectedRoles: ['connectware-admin', 'minimum-access', 'protocol-mapper-agent'],
        protectedUsers: ['admin'],
        pageSize: 20,
        searchSize: 5,
        indexesCache: 5 * 60_000,
        clientRegistryRefreshRate: 5_000,
        certificateFileExtension: 'pem',
    },

    workbenchPath: '/workbench',

    mqtt: { path: '/mqtt', timeout: 6_000, cycle: 500, maxTopicDepth: 20 },

    rst: { cacheLifespan: 500, maxPageSize: 25, reconnectTimeout: 5_000 },

    pageSizes: { short: 10, default: 25, large: 50, max: 100 },

    services: {
        commissioningFile: { extensions: ['yml', 'yaml'], downloadMimeType: 'text/yaml;charset=utf-8' },
        externalUrlBasePath: '/services',
    },

    licenseFileExtension: 'lic',

    infoPageRefreshRate: 20_000,

    interactionThrottle: 500,

    resourcesRefreshThrottle: 5_000,

    resourcesRefreshRate: 5 * 60 * 1_000,

    documentation: 'https://docs.cybus.io',

    searchMinimum: 3,

    logoutWarningPeriod: 10 * 60 * 1_000,

    enableStorybook: false,
}
